import { useMarketStrings } from "module/market/hook/useMarketStrings"

import { Stats } from "component/Stats"

import { usePoolStats } from "../../hook/usePoolStats"

interface PoolInfoProps {
    tickerSymbol: string
}

export function PoolInfo({ tickerSymbol }: PoolInfoProps) {
    const { tvlStr, volume24hStr, tradingFee24hStr } = usePoolStats({ tickerSymbol })
    const { marketPriceStr } = useMarketStrings(tickerSymbol)

    return (
        <>
            <Stats size="xl" label="market price" number={`$${marketPriceStr}`} />
            <Stats size="xl" label="TVL" number={`$${tvlStr}`} />
            <Stats size="xl" label="Volume (24h)" number={`$${volume24hStr}`} />
            <Stats size="xl" label="24h Fees" number={`$${tradingFee24hStr}`} />
        </>
    )
}
